import React from 'react';
import MiniAppEvents from 'src/helpers/miniapp-events';
import { privacyNoticeUrl } from 'src/common';
import './privacy-notice-link.scss';

export const PrivacyNoticeLink = () => {
  const inMiniProgram = MiniAppEvents.isInMiniApp();

  return (
    <div className="has-text-centered has-padding-bottom-4">
      <p className="privacy-notice-content">
        View our&nbsp;
        {inMiniProgram ? (
          <span
            className="privacy-notice-link-miniapp"
            onClick={() => {
              MiniAppEvents.sendMessage({
                messageType: 'new tab',
                data: privacyNoticeUrl,
              });
            }}
          >
            merchant agreement.
          </span>
        ) : (
          <a
            className="privacy-notice-link"
            href={privacyNoticeUrl}
            target="_blank"
            rel="noreferrer"
          >
            Privacy Notice.
          </a>
        )}
      </p>
    </div>
  );
};
